module.exports = __webpack_public_path__ + "img/2_2_3__3.de06ed77.png";